/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filetoolargeerror3Inputs */

const en_filetoolargeerror3 = /** @type {(inputs: Filetoolargeerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File is too large.`)
};

const de_filetoolargeerror3 = /** @type {(inputs: Filetoolargeerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Datei ist zu groß.`)
};

/**
* | output |
* | --- |
* | "File is too large." |
*
* @param {Filetoolargeerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filetoolargeerror3 = /** @type {((inputs?: Filetoolargeerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filetoolargeerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filetoolargeerror3(inputs)
	return de_filetoolargeerror3(inputs)
});
export { filetoolargeerror3 as "fileTooLargeError" }